export enum StoreOrderStatus {
  created = 'created',
  chargeSuccessful = 'successfulCharge',
  chargeError = 'errorCharge',
  voidSuccessful = 'successfulVoid',
  voidPending = 'pendingVoid',
  voidError = 'errorVoid',
  pointIssuanceSuccessful = 'successfulPointIssuance',
  pointIssuanceError = 'errorPointIssuance',
  pointVoidSuccessful = 'successfulPointVoid',
  pointVoidError = 'errorPointVoid',
  confirmed = 'confirmed',
  error = 'error',
}

export enum VendorTypes {
  sapura = 'sapura',
  sentinel = 'sentinel',
  setel = 'setel',
}

export enum StorePaymentProvider {
  wallet = 'wallet',
  card = 'card',
}
